import { Box, Grid, Stack, Typography } from "@mui/material";
import DataModeBadge from "./DataModeBadge";
import { useTranslation } from "react-i18next";

const HeatmapPanel = ({ zones = [], metric = "risk", dataMode = { mode: "mock" } }) => {
  const { t } = useTranslation();
  const max = Math.max(...zones.map((zone) => Number(zone[metric] || 0)), 1);
  return (
    <Stack spacing={2}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2}>
        <Typography variant="h5">{t("platform.heatmaps.titleWithMetric", { metric: t(`platform.heatmaps.metrics.${metric}`, metric) })}</Typography>
        <DataModeBadge {...dataMode} />
      </Stack>
      <Grid container spacing={1.5}>
        {zones.map((zone) => {
          const intensity = Math.max(Number(zone[metric] || 0) / max, 0.08);
          return (
            <Grid item xs={12} sm={6} md={4} lg={2} key={`${zone.zone}-${metric}`}>
              <Box sx={{
                minHeight: 126,
                borderRadius: 1,
                p: 1.5,
                border: "1px solid",
                borderColor: "divider",
                bgcolor: `rgba(239, 68, 68, ${Math.min(intensity, 0.84)})`,
                color: intensity > 0.48 ? "#fff" : "text.primary",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}>
                <Typography fontWeight={600}>{zone.zone}</Typography>
                <Box>
                  <Typography variant="caption">{zone.camera}</Typography>
                  <Typography variant="h4">{zone[metric]}</Typography>
                </Box>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Stack>
  );
};

export default HeatmapPanel;
